import React from "react";
import { useLocation } from "react-router-dom";

export function useHeaderScroll() {
  const location = useLocation();
  const [scrolled, setScrolled] = React.useState(location.pathname !== "/");

  React.useEffect(() => {
    const rootElement = document.getElementById("root");
    const scrollingElement = document.scrollingElement;

    const getScrollTop = () => {
      const rootScroll = rootElement ? rootElement.scrollTop : 0;
      const docElScroll = document.documentElement.scrollTop || 0;
      const bodyScroll = document.body.scrollTop || 0;
      const scrollingElScroll = scrollingElement ? scrollingElement.scrollTop : 0;
      const windowScroll = window.scrollY || window.pageYOffset || 0;
      return Math.max(rootScroll, docElScroll, bodyScroll, scrollingElScroll, windowScroll);
    };

    const updateScrolled = () => {
      const isScrolled = getScrollTop() > 10 || location.pathname !== "/";
      setScrolled((prev) => (prev === isScrolled ? prev : isScrolled));
    };

    const onScroll = () => updateScrolled();

    window.addEventListener("scroll", onScroll, { passive: true });
    document.addEventListener("scroll", onScroll, { passive: true, capture: true });
    window.addEventListener("resize", onScroll, { passive: true });
    if (scrollingElement) scrollingElement.addEventListener("scroll", onScroll, { passive: true });
    if (rootElement) rootElement.addEventListener("scroll", onScroll, { passive: true });

    updateScrolled();

    return () => {
      window.removeEventListener("scroll", onScroll);
      document.removeEventListener("scroll", onScroll, true);
      window.removeEventListener("resize", onScroll);
      if (scrollingElement) scrollingElement.removeEventListener("scroll", onScroll);
      if (rootElement) rootElement.removeEventListener("scroll", onScroll);
    };
  }, [location.pathname]);

  return scrolled;
}
